





























import Vue from "vue";
import TeamCalendarEventRow from "@/components/TeamCalendar/TeamCalendarEventRow.vue";
import TeamCalendarEventPopup from "@/components/TeamCalendar/TeamCalendarEventPopup.vue";
import TeamCalendarModule from "../../views/Calendar/TeamCalendarModule";
import { getModule } from "vuex-module-decorators";
import { Moment } from "moment";

interface State {
  day: any;
  module: TeamCalendarModule;
}

export default Vue.extend({
  name: "GridView",
  components: {
    TeamCalendarEventPopup
  },
  props: {
    events: {
      type: Array,
      default: () => []
    }
  },
  data(): State {
    return {
      day: null,
      module: getModule(TeamCalendarModule, this.$store)
    };
  },
  methods: {
    viewDay(day: any) {
      // this.$emit("viewDay", day);
      console.log(day.date);
      this.day = day.date;
    }
  },
  computed: {
    layout(): string {
      return this.day ? "day" : "month";
    },
    focus: {
      get(): Date | Moment {
        return this.day || this.month;
      },
      set(val: Date | Moment) {
        console.log({ val });
        this.module.setMonth(val);
        this.day = null;
      }
    },
    month: {
      get(): Date | Moment {
        return this.module.selectedMonth;
      },
      set(val: Date | Moment) {
        this.module.setMonth(val);
      }
    }
  }
});
